import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicSpa from "../Components/ProjPicSpa";

const ProjectPageSpa = () => {
    return (
        <>
            <Navbar />
            <ProjPicSpa />
            <Footer />
        </>
    );
};

export default ProjectPageSpa;
